import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/products/audioguide/webp/a1-bright-mobile.webp")